module.exports = __webpack_public_path__ + "media/images/charts/PemegangSaham-PieChart2-d8f2e85258a9514d35db268f07387992.jpg";